import { implementSetAllNavTabDetailsMutation } from '../../../../dt-plugins/sidewindow/nav-tab';
import * as types from './types';
import { head, uniq, prop } from 'ramda';

export const venueMutations = {

  [types.VenueList.SET.ALL](state, payload) {
    state.venueList = payload;

  },
  [types.SET_BOOKING_VENUES](state, payload) {
    state.venues = payload;
  },
  [types.SET_SELECTED_VENUE](state, payload) {
    state.selectedVenue = payload;
  },
  [types.SET_SELECTED_VENUE_LOADING](state, payload) {
    state.selectedVenueLoading = payload;
  },
  [types.SET_VENUE_DETAILS_FLAG](state, payload) {
    state.venueDetailsFlag = payload;
  },
  [types.SET_VENUE_START_ROW](state, payload) {
    state.venueStartRow = payload;
  },
  [types.VENUE_LOCATION.SET.SINGLE](state, payload) {
    state.selectedVenue.location = payload;
  },
  [types.VENUE_RELATED_CONTACTS.SET.ALL](state, payload) {
    state.selectedVenue.contact_relations = payload;
  },
  [types.SET_VENUE_LOCATION_COMMENTS](state, payload) {
    const status = head(uniq(payload.comments.map(prop('status'))));
    const key = status === 'private' ? 'private_comments' : 'public_comments';
    state.selectedVenue[key] = payload.comments;
  },
  [types.DELETE_VENUE_LOCATION_COMMENTS](state, payload) {
    const { status, comment_id } = payload;
    const key = status === 'private' ? 'private_comments' : 'public_comments';
    state.selectedVenue[key] = state.selectedVenue[key].filter(c => {
      if (c.comment_id == comment_id) {
        return false;
      } else {
        return true;
      }
    })
  },
  [types.VENUE_FILES.DELETE.SINGLE](state, payload) {
    const { file_id, file_relation_id } = payload;
    state.selectedVenue.files = state.selectedVenue.files.filter(f => {
      if (f.file_id == file_id && f.file_relation_id == file_relation_id) {
        return false;
      } else {
        return true;
      }
    })
  },
  [types.VENUE_FILES.SET.ALL](state, payload) {
    state.selectedVenue.files = payload;
  },
  [types.VENUE_FEATURES.SET.ALL](state, payload) {
    state.selectedVenue.location.feature = payload;
  },
  [types.UPDATE_VENUE_CUSTOM_FIELD]( state, payload) {
    state.selectedVenue.fields = payload;
  },
  ...implementSetAllNavTabDetailsMutation(types.VenueDetails, 'venueDetails'),
}